import React from "react";
import HeaderOriginal from "../components/HeaderOriginal/HeaderOriginal";
import StickyNavBar from "../components/Navigation/StickyNavBar";
import Footer from "../components/Footer";
import Container from "../components/Container";
import AboutTheAssociation from "../components/AboutUs/AboutTheAssociation";
import Values from "../components/AboutUs/Values";
import Objectives from "../components/AboutUs/Objectives";
import Missions from "../components/AboutUs/Missions";
import Vision from "../components/AboutUs/Vision";
const WhoAreWePage = () => {
  return (
    <>
      <HeaderOriginal></HeaderOriginal>
      <StickyNavBar></StickyNavBar>
      <Container>
        <div className="py-12 md:py-16 lg:py-24">
          <h1 className="font-bold text-lg md:text-xl lg:text-2xl mb-2 md:mb-4 text-[#21497C] text-center">
            نبذة عنا
          </h1>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <AboutTheAssociation />
          </div>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <Values />
          </div>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <Vision />
          </div>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <Missions />
          </div>
          <div className="shadow-lg py-6 px-4 md:py-12 md:px-8 lg:py-16 lg:px-10">
            <Objectives />
          </div>
        </div>
      </Container>
      <Footer></Footer>
    </>
  );
};

export default WhoAreWePage;
